import { FC } from "react";

import { Box } from "@mui/material";
import { PaymentMethod } from "@simplyk/common";

import { useTranslate } from "@/common/hooks/useTranslate";
import {
  BaseFormPaymentMethod,
  BaseFormPaymentMethodProps,
} from "@/forms-design-system/FormPaymentMethod/BaseFormPaymentMethod";
import { StripeCheque } from "@/icons/external";
import GiftSmall from "@/icons/outlined/giftSmall.svg";

interface OfflinePaymentMethodProps extends Omit<BaseFormPaymentMethodProps, "icon" | "label" | "ref"> {
  paymentMethod: PaymentMethod.Cheque | PaymentMethod.Daf;
  customMessage?: string | null;
}

export const OfflinePaymentMethod: FC<OfflinePaymentMethodProps> = ({
  paymentMethod,
  customMessage,
  children,
  ...props
}) => {
  const { t } = useTranslate();
  const isCheque = paymentMethod === PaymentMethod.Cheque;

  return (
    <BaseFormPaymentMethod
      {...props}
      label={t("common", isCheque ? "paymentMethod.cheque" : "paymentMethod.daf")}
      icon={
        <Box display="flex" alignItems="center" justifyContent="center" width="100%" height="100%">
          <Box
            component={isCheque ? StripeCheque : GiftSmall}
            viewBox={isCheque ? "0 2 15.7193 11.7895" : "0 0 20 20"}
            sx={(theme) => ({
              width: theme.spacing(isCheque ? 7 / 3 : 2.5),
              height: theme.spacing(isCheque ? 1.75 : 2.5),
              flexShrink: 0,
            })}
          />
        </Box>
      }
    >
      {isCheque && customMessage ? (
        <Box
          padding={1.5}
          sx={(theme) => ({
            borderRadius: theme.radius(1),
            backgroundColor: theme.palette.formsComponents.paymentMethod.chequeCustomMessageBackgroundColor,
            border: `1px solid ${theme.palette.formsComponents.paymentMethod.chequeCustomMessageBorderColor}`,
            color: theme.palette.formsComponents.paymentMethod.chequeCustomMessageTextColor,
            whiteSpace: "pre-wrap",
          })}
        >
          {customMessage}
        </Box>
      ) : (
        children
      )}
    </BaseFormPaymentMethod>
  );
};
